import SectionHeading from './SectionHeading.jsx';
import { processSteps } from '../data/siteData.js';

export default function Process() {
  return (
    <section className="section process-section">
      <div className="container">
        <SectionHeading
          eyebrow="Hogyan indulunk?"
          title="Négy egyszerű lépés. Nulla találgatás."
          text="Már az első beszélgetéstől tisztán fogod látni, hogy mi a következő feladat és miért azt csináljuk."
          align="center"
        />

        <div className="process-line" aria-hidden="true" />
        <div className="process-grid">
          {processSteps.map(({ number, icon: Icon, title, text }) => (
            <article className="process-card" key={number}>
              <div className="process-number">{number}</div>
              <div className="process-icon">
                <Icon size={23} />
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
